module.exports = __webpack_public_path__ + "static/media/citySketch.b429b0c9.jpg";